import axiosInstance from '../../api/axiosInstance'

/**
 * Module on/off probe for the agent, shared by every caller.
 *
 * Same memoised single-request shape as chatStatus.js / assistantStatus.js, so
 * the dock and the settings page cost one HTTP call between them.
 */

let statusPromise = null

export function getAgentEnabled() {
    if (!statusPromise) {
        statusPromise = axiosInstance
            .get('agent/status')
            .then((res) => Boolean(res.data?.enabled))
            .catch(() => false)
    }
    return statusPromise
}

/** Let the settings page force a re-check after the admin flips the switch. */
export function resetAgentStatus() {
    statusPromise = null
}
